import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
/* eslint-disable */
import { login as _login, logout as _logout, refreshToken as _refreshToken } from '@/api/user';
import { getToken, setToken, removeToken, setUserId, setIat, setExp, removeUserId, getRefreshToken, setRefreshToken, removeRefreshToken } from '@/utils/auth';
import { resetRouter } from '@/router';
import CryptoJS from '/public/crypto-js';
var getDefaultState = function getDefaultState() {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    refreshToken: getRefreshToken()
  };
};
var encryptByDES = function encryptByDES(message) {
  var key = 'kEHrDooxWHKWCWtfeSxvDvgqZqa';
  var keyHex = CryptoJS.enc.Utf8.parse(key);
  var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};
var states = getDefaultState();
var mutations = {
  RESET_STATE: function RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN: function SET_REFRESH_TOKEN(state, token) {
    state.refreshToken = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      _login({
        userId: encryptByDES(username.trim()),
        password: encryptByDES(password)
      }).then(function (response) {
        if (response.code !== '0000000000') reject(response);
        commit('SET_TOKEN', response.result.jwt_token);
        setToken(response.result.jwt_token);
        commit('SET_NAME', username.trim());
        // 存储登录时间和过期时间
        setIat(new Date().getTime().toString());
        var exp = new Date().setSeconds(response.result.accessTokenValidity).toString();
        setExp(exp);
        //  存储刷新token
        setRefreshToken(response.result.refresh_token);
        commit('SET_REFRESH_TOKEN', response.result.refresh_token);
        setUserId(username.trim()); // 添加userid

        // commit('SET_TOKEN', data.token)
        // setToken(data.token)
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve) {
      // getInfo(state.token).then(response => {
      // const { data } = response
      // if (!data) {
      //   return reject('Verification failed, please Login again.')
      // }
      // const { name, avatar } = data
      commit('SET_NAME', state.name);
      resolve();
      // commit('SET_AVATAR', avatar)
      // resolve(data)
      // }).catch(error => {
      //   reject(error)
      // })
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      _logout().then(function () {
        removeToken(); // must remove  token  first
        removeRefreshToken();
        resetRouter();
        commit('RESET_STATE');
        dispatch('settings/resetState', null, {
          root: true
        });
        removeUserId();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  refreshToken: function refreshToken(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _refreshToken({
        refreshToken: state.refreshToken
      }).then(function (response) {
        if (response.code !== '0000000000') reject(response);
        commit('SET_TOKEN', response.result.jwt_token);
        setToken(response.result.jwt_token);
        setRefreshToken(response.result.refresh_token);
        setIat(new Date().getTime().toString());
        var exp = new Date().setSeconds(response.result.accessTokenValidity).toString();
        setExp(exp);
        commit('SET_REFRESH_TOKEN', response.result.refresh_token);
        resolve(response);

        // commit('SET_TOKEN', data.token)
        // setToken(data.token)
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  logoutClear: function logoutClear(_ref5) {
    var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
    return new Promise(function (resolve) {
      removeToken(); // must remove  token  first
      removeRefreshToken();
      resetRouter();
      removeUserId();
      commit('RESET_STATE');
      dispatch('settings/resetState', null, {
        root: true
      });
      resolve();
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve) {
      removeToken(); // must remove  token  first
      removeUserId();
      commit('RESET_STATE');
      dispatch('settings/resetState', null, {
        root: true
      });
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: states,
  mutations: mutations,
  actions: actions
};